











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DueDateToggle_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DueDatePicker_task"
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node ).hash = "16e46cdd0ca46add547bf57e2acec864";

export default node;
